import { oneMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { MEMBERSHIP_DOMAIN_QUERY } from '../constants/membershipDomainConstants';

export const loadMembershipDomain = oneMembershipDomainFetchye(MEMBERSHIP_DOMAIN_QUERY, {}, {})
